import { DEFAULT_DATE_PICKER_EOD, type FeeModeEnum, type PersistedTourState } from '@talos/kyoko';
import { createContext, useContext } from 'react';
import { getDefaultPinnedSections } from './AppConfigProvider/replaceLegacyPinNavigationSidebarConfig';
import type { PersistedShowcaseState } from './ShowcaseProvider/DefaultShowcasesConfig';
import type { CustomEOD } from './customEOD';

export const DefaultDisplaySettingsConfig = {
  termsAccepted: false,
  pinNavigationSidebar: true,
  pinNavigationSidebarSection: getDefaultPinnedSections(true),
  showAllInPrices: null as FeeModeEnum | null | undefined,
  showFirmLiquidity: false,
  showDelta1BPS: false,
  showTotalEstimates: true,
  homeCurrency: 'USD',
  customEOD: DEFAULT_DATE_PICKER_EOD as CustomEOD,
  latestReleaseNotesRead: undefined as string | undefined,
  otcSettlementShowAll: false,
  showSidebarLabels: true,
  shouldConfirmCloseTab: true,
  adminCounterpartiesShowInactiveAccounts: true,
  /** Whether guide text is visible in AppWideDrawer entity admin drawers */
  showAppwideDrawerGuide: false,
  /** App version when the user first used the app. Used to filter showcases and tours. */
  firstSeenVersion: '2.54.0' as string | null,
  /** Persisted tour state (which tours have been seen and at which step) */
  seenTours: {} as PersistedTourState,
  /** Persisted showcase state (which showcases have been seen by the user) */
  seenShowcases: {} as PersistedShowcaseState,
};
export const DefaultDisplaySettingsMethods = {
  setShowSidebarLabels: (showSidebarLabels: boolean) => {},
  setAdminCounterpartiesShowInactiveAccounts: (adminCounterpartiesShowInactiveAccounts: boolean) => {},
  setShowAppwideDrawerGuide: (showAppwideDrawerGuide: boolean) => {},
  setTermsAccepted: (termsAccepted: boolean) => {},
  setPinNavigationSidebar: (pinNavigationSidebar: boolean) => {},
  setPinNavigationSidebarSection: (pinNavigationSidebar: boolean, section: string) => {},
  setPinAllNavigationSidebarSections: (pinNavigationSidebar: boolean) => {},
  setShowAllInPrices: (showAllInPrices: FeeModeEnum | null) => {},
  setShowFirmLiquidity: (showFirmLiquidity: boolean) => {},
  setShowDelta1BPS: (showDelta1BPS: boolean) => {},
  setShowTotalEstimates: (showTotalEstimates: boolean) => {},
  setHomeCurrency: (homeCurrency: string) => {},
  setCustomEOD: (customEOD: CustomEOD) => {},
  setLatestReleaseNotesRead: (latestReleaseNotesRead: string | undefined) => {},
  setOTCSettlementShowAll: (otcSettlementShowAll: boolean) => {},
  setSeenTours: (seenTours: PersistedTourState) => {},
  setSeenShowcases: (seenShowcases: PersistedShowcaseState) => {},
  setShouldConfirmCloseTab: (shouldConfirmCloseTab: boolean) => {},
};
export const DefaultDisplaySettingsContext = { ...DefaultDisplaySettingsConfig, ...DefaultDisplaySettingsMethods };
export const DisplaySettingsContext = createContext(DefaultDisplaySettingsContext);
DisplaySettingsContext.displayName = 'DisplaySettingsContext';
export const useDisplaySettings = () => useContext(DisplaySettingsContext);
